import { createRouter, createWebHistory } from 'vue-router'

import { useAuthStore } from '@/stores/authStore'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/LoginPage.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/',
      redirect: '/catalog',
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: () => import('@/pages/CatalogPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/catalog/:id',
      name: 'medicine-detail',
      component: () => import('@/pages/MedicineDetailPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/pages/CartPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import('@/pages/CheckoutPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/order-success/:id',
      name: 'order-success',
      component: () => import('@/pages/OrderSuccessPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/my-orders',
      name: 'my-orders',
      component: () => import('@/pages/MyOrdersPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/orders/:id',
      name: 'order-details',
      component: () => import('@/pages/OrderDetailsPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/my-debts',
      name: 'my-debts',
      component: () => import('@/pages/MyDebtsPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/my-debts/:receiptId',
      name: 'receipt-details',
      component: () => import('@/pages/ReceiptDetailsPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/pages/ProfilePage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: () => import('@/pages/ChangePasswordPage.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/catalog',
    },
  ],
})

router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore()

  // Восстановление сессии до первой проверки доступа
  if (!authStore.bootstrapped) {
    await authStore.bootstrap()
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return next({ name: 'login', query: { redirect: to.fullPath } })
  }
  if (to.meta.requiresGuest && authStore.isAuthenticated) {
    return next({ name: 'catalog' })
  }
  next()
})

export default router

// Типы meta маршрутов
declare module 'vue-router' {
  interface RouteMeta {
    requiresAuth?: boolean
    requiresGuest?: boolean
  }
}
